import Vue from 'vue';
import router from '@/routes/index';

function errorResponseHandler(error) {
    if (error) {
        // 23.09.14
        // 운영 IIS 웹서버에서 새로고침 시 에러를 가로채기 때문에
        // 토큰 만료 시 301 에러를 발생 시킨 후에 login 페이지로 리다이렉트
        if (error.response.status == 401 || error.response.status == 301) {
            // E9003 : 다른 브라우저에서 로그인되어 이 세션이 종료된 경우
            const code = error.response.data && error.response.data.errorCode;
            Vue.prototype.$session.destroy();
            window.location = code === 'E9003' ? '/login?reason=duplicate' : '/login';
        } else {
            router.push({ name: 'errorPage' });
        }
    } else {
        router.push({ name: 'errorPage' });
    }
}

export function setInterceptors(instance) {
    // Add a request interceptor
    instance.interceptors.request.use(
        config => {
            if (Vue.prototype.$session.get('token')) config.headers.Authorization = Vue.prototype.$session.get('token');
            return config;
        },
        error => {
            console.log("setInterceptors Request error : "+error);
            return Promise.reject(error.response);
        },
    );

    instance.interceptors.response.use(
        response => {
            if (response.headers.authorization) {
                Vue.prototype.$session.set('token', response.headers.authorization);
            }
            return response;
        },
        error => {
            console.log("setInterceptors Response error : "+error);
            errorResponseHandler(error);
            // if (error.response.status === 401) {
            //     Vue.prototype.$session.destroy();
            //     window.location = '/login';
            // }
        });

    return instance;
}